export default {
    data() {
        return {};
    },
    methods: {
        modalToggle(modal) {
            const body = document.querySelector("body");
            this[modal] = !this[modal];
            this[modal]
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },

    },
};
